import { NotifyHelper } from "../../../helpers/toast";
import { eXetThucTapActionsObj } from "../../action-types/xet-thuc-tap/IXetThucTapActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xetThucTapActions = {
    ...generateActions(eXetThucTapActionsObj, "XET_THUC_TAP"),
    ...generateActionForKey(eXetThucTapActionsObj, "XET_THUC_TAP", "XET_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
    ...generateActionForKey(eXetThucTapActionsObj, "XET_THUC_TAP", "XET_THEO_MON_NGHIEP_VU_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
}